// Scroll-reveal — reveals content sections as they scroll into view.
//
// Uses IntersectionObserver (not a CSS scroll-timeline) so it works in every
// browser and is immune to the theme's scroll-container setup. Progressive
// enhancement: the hidden start state lives behind the `scroll-reveal-active`
// class, which is only added here — so if this script never runs (or motion is
// reduced, or the merchant disabled it), content stays fully visible.

(() => {
  const main = document.querySelector('main[data-scroll-reveal-enabled="true"]');
  if (!main) return;

  // Respect the visitor's motion preference — show everything, animate nothing.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Enables the hidden start state (see snippets/scroll-reveal.liquid).
  document.documentElement.classList.add('scroll-reveal-active');

  const reveal = (el) => el.classList.add('scroll-revealed');

  const observer = new IntersectionObserver(
    (entries, obs) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        reveal(entry.target);
        obs.unobserve(entry.target);
      }
    },
    // threshold 0: fire as soon as any part enters, so sections taller than the
    // viewport still reveal (a positive threshold could never be reached).
    { threshold: 0, rootMargin: '0px 0px -8% 0px' },
  );

  const isTarget = (el) => el.matches('.shopify-section, [data-reveal]') && el.dataset.reveal !== 'none';

  // Register a root and its descendants: reveal anything already in (or above)
  // the viewport in the same tick — before the browser paints the hidden state,
  // so above-the-fold content never flashes — and observe the rest.
  const register = (root) => {
    const viewportHeight = window.innerHeight;
    const targets = isTarget(root) ? [root] : [];
    for (const el of root.querySelectorAll('.shopify-section, [data-reveal]')) {
      if (el.dataset.reveal !== 'none') targets.push(el);
    }
    for (const el of targets) {
      if (el.classList.contains('scroll-revealed')) continue;
      if (el.getBoundingClientRect().top < viewportHeight) {
        reveal(el);
      } else {
        observer.observe(el);
      }
    }
  };

  register(main);

  // Re-register sections added or re-rendered after load (theme editor,
  // Section Rendering) so they never stay stuck in the hidden state.
  document.addEventListener('shopify:section:load', (event) => {
    if (main.contains(event.target)) register(event.target);
  });
})();
